
// Functions
import { useEffect, useState } from 'react';
import * as ComponentFunctions from './SettlementResumeForm.Functions';
import { Input, MessageBarBody, MessageBarTitle, Switch, Textarea } from '@fluentui/react-components';
import { connect } from 'react-redux';
import { GuideDrawer, GuideDrawerForm } from '../../../theme/components/GuideDrawer';
import { GuideField } from '../../../theme/components/GuideField';
import { GuideMessageBar } from '../../../theme/components/GuideMessageBar';


interface FormValidation {
    success: boolean;
    errors: string[];
}

/** Ítem de resumen de una liquidación: nombre, si está observado y comentarios. */
const SettlementResumeFormComponent = (props: ComponentFunctions.Props) => {

    // form status
    const [submittedForm, setSubmittedForm] = useState<boolean>(false);
    const [FormValidationStatus] = useState<FormValidation | undefined>();

    // initial values
    useEffect(() => {
        if (props.SettlementResume) {
            setDescription(props.SettlementResume.description);
            setComments(props.SettlementResume.comments);
            setHaveWarning(props.SettlementResume.haveWarning);
        }
    }, [props.SettlementResumeId]);

    // form properties
    const [description, setDescription] = useState<string>();
    const [comments, setComments] = useState<string>();
    const [haveWarning, setHaveWarning] = useState<boolean>(false);

    const ResetForm = () => {
        setSubmittedForm(false);
        setDescription(undefined);
        setComments(undefined);
        setHaveWarning(false);
    }

    const HandleCancelForm = () => {
        ResetForm();
        props.dismissPanel();
    };

    // El guardado del ítem de resumen todavía no está habilitado (el alta / edición en el store están pendientes).
    const HandleSaveForm = () => undefined;

    return (
        <GuideDrawer
            open={props.isOpen}
            size="small"
            title="Información del item resumen"
            onDismiss={props.dismissPanel}
            testId="settlement-resume-form-drawer"
            secondaryAction={{ label: 'Cancelar', onClick: HandleCancelForm }}
            primaryAction={{ label: 'Guardar', onClick: HandleSaveForm }}
        >
            {submittedForm && !FormValidationStatus?.success && (
                <GuideMessageBar intent="error" layout="multiline">
                    <MessageBarBody>
                        <MessageBarTitle>Revise la información suministrada:</MessageBarTitle>
                        <ul>
                            {FormValidationStatus?.errors?.map(
                                (Error: string, index: number) => (
                                    <li key={index}>{Error}</li>
                                )
                            )}
                        </ul>
                    </MessageBarBody>
                </GuideMessageBar>
            )}
            <GuideDrawerForm testId="settlement-resume-form">
                <GuideField
                    label="Nombre"
                    required
                    error={submittedForm === true && description === undefined ? 'Campo requerido' : undefined}
                >
                    <Input
                        name="resume-name"
                        type="text"
                        autoComplete="off"
                        onChange={(_event, data) => setDescription(data.value)}
                        value={description ?? ''}
                    />
                </GuideField>
                <Switch
                    label="¿Marcar como observado?"
                    checked={haveWarning}
                    onChange={(_event, data) => setHaveWarning(!!data.checked)}
                />
                <GuideField label="Comentarios">
                    <Textarea
                        name="resume-comments"
                        rows={3}
                        resize="vertical"
                        autoComplete="off"
                        onChange={(_event, data) => setComments(data.value)}
                        value={comments ?? ''}
                    />
                </GuideField>
            </GuideDrawerForm>
        </GuideDrawer>
    );
}

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(SettlementResumeFormComponent as any)
